import { Component } from '@angular/core';

@Component({
  selector: 'app-right-arrow-icon',
  templateUrl: './right-arrow-icon.component.html',
  styleUrl: './right-arrow-icon.component.scss',
})
export class RightArrowIconComponent {}
